import React, { useState, useEffect } from "react";
import { ROW_COUNT } from "../helpers/variableHelper";
import { flexRender, getCoreRowModel, getSortedRowModel, SortingState, ColumnFiltersState, useReactTable } from "@tanstack/react-table";
import { Form } from "react-bootstrap";
import asc from "../assets/img/asc.png";
import desc from "../assets/img/desc.png";
import { ITipo_Campo, dictionaryType } from "../helpers/IFormHelper";
import Loading from "../cross/Loading";
import InputColumn from "../modules/administration/InputColumn";
import { IPagination } from "./AdminListaPagination";
import { IAdminListaPagination } from "./IAdminListaPagination";

const RenderOptions = (header: any, filterValue: any, filterHandler: any, onChangeFilter: any, id: string) => {
  if (header.id != "editar" && !header.column.columnDef.disableSorting) {
    if (header.column.columnDef.tipo === ITipo_Campo.check) {
      let val = "";
      if (filterValue != null && filterValue[header.id] != null) {
        val = filterValue[header.id] ? "1" : "0";
      }

      return (
        <select
          value={val}
          className="w-100 paddingSelect rounded border border-1"
          onChange={(input: any) => {
            filterHandler(header.id, input.currentTarget.value, header.column.columnDef.tipo);
          }}>
          <option value="">...</option>
          <option value="1">Sí</option>
          <option value="0">No</option>
        </select>
      );
    } else if (header.column.columnDef.tipo === ITipo_Campo.date) {
      return (
        <Form.Control
          className="calendarioFiltro"
          onChange={(input: any) => {
            filterHandler(header.id, input.currentTarget.value, header.column.columnDef.tipo);
          }}
          type="date"
          name={id}
        />
      );
    } else {
      let tipo: number = header.column.columnDef.tipo as number;
      return (
        <div>
          <InputColumn
            type={dictionaryType(tipo) ?? ""}
            onchange={onChangeFilter}
            headerId={header.id}
            tipo={header.column.columnDef.tipo}
            className="w-100 rounded border border-1 "
          />
        </div>
      );
    }
  }
};

export const AdminListaPaginationTab = ({
  data,
  hideExport,
  selectedItem,
  callback,
  loadFromSelected,
  isLoading,
  hideTable,
  parentchild,
  reload,
  resultPerPage = ROW_COUNT,
  defaultSortBy,
  sortDirection,
  totalPages,
  filter,
  exportar,
  hideAdd,
  hideReload,
  title,
  columnsDef,
  callbackRenderForm,
  callbackUpdatePageSize,
  hidePagination,
  hideFilters,
  autoLoad = true,
}: IAdminListaPagination) => {
  const [sorting, setSorting] = React.useState<SortingState>([]);
  const [columnFilters, setFiltering] = React.useState<ColumnFiltersState>([]);
  const [show, setShow] = useState(false);
  const [pagination, setPagination] = useState<IPagination>({
    PAGINA: 1,
    PAGINADO: resultPerPage,
    ORIENTACION: sortDirection,
    ORDENADOPOR: defaultSortBy,
  });
  const [columns, setColumns] = useState(columnsDef);
  const [selected, setSelected] = useState(selectedItem !== undefined ? selectedItem : ({} as any));
  const [id] = useState("");
  const [filterValue, setFilter] = useState({} as any);
  const [orderBy, setOrderBy] = useState("DESC");
  const [orderByColumn, setOrderByColumn] = useState("");
  const [isLoadingComponent, setIsLoadingComponent] = useState(false);
  const [selectedPageSize, setSelectedPageSize] = useState(ROW_COUNT);
  let valor = "";
  let contador = 0;

  useEffect(() => {
    //ejecutar al abrir el popup
    if (callbackRenderForm && show) {
      callbackRenderForm(selected);
    }
    if (!show && autoLoad) {
      setIsLoadingComponent(true);
      reload(filterValue);
      setIsLoadingComponent(false);

      let nColumns = columns;
      nColumns.forEach((c) => (c.errorEmpty = false));
      setColumns(nColumns);
    }
  }, [show]);
  useEffect(() => {
    if (columnsDef) {
      setColumns(columnsDef as any);
    }
  }, [columnsDef]);
  useEffect(() => {}, [filterValue]);
  const table = useReactTable({
    data,
    columns,
    state: {
      sorting,
      columnFilters,
    },
    manualSorting: true,
    onColumnFiltersChange: setFiltering,
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    debugTable: true,
  });

  const pageHandler = (page: number) => {
    let handler = filterValue || {};
    handler["PAGINA"] = page;
    setFilter(handler);
    if (filter) filter(handler, true);
  };
  const sortHandler = (column: string, direction: string) => {
    let handler = filterValue || {};
    handler["ORDENADOPOR"] = column;
    handler["ORIENTACION"] = direction;
    setFilter(handler);

    if (filter) filter(handler);
  };
  const deleteSorting = () => {
    let handler = filterValue || {};
    handler["ORDENADOPOR"] = "ID";
    handler["ORIENTACION"] = "DESC";
    setOrderByColumn("");
    setOrderBy("DESC");
    setFilter(handler);
    if (filter) filter(handler);
  };

  const filterHandler = (id: string, value: any, type: ITipo_Campo) => {
    //
    let handler = filterValue || {}; //
    handler.PAGINA = 1;

    if (type == ITipo_Campo.check) {
      if (value === "...") {
        delete handler[id];
      } else {
        if (value === "") {
          value = null;
        } else if (value === "1") {
          value = true;
        } else {
          value = false;
        }

        handler[id] = value;
      }
    } else {
      handler[id] = value;
    }
    setFilter(handler);
    if (pagination) {
      if (filter) filter(handler);
    }
    callback({
      ...pagination,
      ...handler,
    });
  };

  const onChangeFilter = (headerId: string, value: string, tipo: ITipo_Campo) => {
    filterHandler(headerId, value, tipo);
  };

  const initializeFilter = () => {
    let handler = {
      PAGINA: 1,
      PAGINADO: ROW_COUNT,
      ORDENADOPOR: "ID",
      ORIENTACION: "DESC",
    };
    setFilter(handler);
  };

  return (
    <section className={`${hideTable ? "hidden" : ""}`}>
      <div className="row">
        <div className="col-12 p-2">
          <div className="rounded bg-white p-2 shadow">
            <div className="container-fluid mb-4">
              <h1 className="titPrincipal colorTit mt-2">{title === "TP" ? "" : title}</h1>
              <div className="row mb-1">
                <div className="col-6">
                  {hideAdd || (
                    <button
                      data-testid="testbtnagregar"
                      className="btn btn-primary btn-sm"
                      onClick={() => {
                        setShow(true);
                        setSelected({});
                        loadFromSelected({});
                      }}>
                      {" "}
                      <i className="bi bi-plus-circle-fill"></i> Agregar
                    </button>
                  )}
                </div>
                <div className="col-3"></div>

                <div className="col-3 text-end">
                  <button
                    data-testid="testbtnrecargar"
                    className="btn btn-outline-secondary btn-sm"
                    hidden={hideReload}
                    onClick={async () => {
                      setIsLoadingComponent(true);
                      initializeFilter();
                      setOrderByColumn("");
                      setOrderBy("");

                      await reload();
                      setIsLoadingComponent(false);
                    }}>
                    {" "}
                    <i className="bi bi-arrow-clockwise"></i> Recargar
                  </button>
                  <button
                    hidden={true}
                    data-testid="testsort"
                    onClick={() => {
                      sortHandler("", "");
                    }}></button>
                  <button
                    hidden={true}
                    data-testid="testdeletesort"
                    onClick={() => {
                      deleteSorting();
                    }}></button>
                  <button
                    hidden={true}
                    data-testid="testfilter"
                    onClick={() => {
                      filterHandler("", "", ITipo_Campo.text);
                    }}></button>
                  <button
                    hidden={true}
                    data-testid="testfilterchek"
                    onClick={() => {
                      filterHandler("", "", ITipo_Campo.check);
                    }}></button>
                </div>
              </div>
              <div className="row">
                <div className="col-12 p-0">
                  <div className="table-responsive">
                    {isLoading || isLoadingComponent ? (
                      <Loading></Loading>
                    ) : (
                      <table className={`table table-hover tablaTLC table-sm ${title === "TP" ? "alignMiddle" : ""}`}>
                        <thead>
                          {table.getHeaderGroups().map(
                            (
                              headerGroup // NOSONAR "Se aplica en esta linea ya que SONAR nos arroja 50 como valor de complejidad cognitiva. Esta función realiza varias validaciones al ser un componente reutilizable, que se necesita para armar la cabecera de las grillas de los módulos".
                            ) => (
                              <tr key={headerGroup.id}>
                                {headerGroup.headers.map((header: any) => {
                                  if (!header.column.columnDef.hide) {
                                    return (
                                      <React.Fragment key={header.id}>
                                        <th key={header.id} colSpan={header.colSpan}>
                                          {header.isPlaceholder ? null : (
                                            <div
                                              className={header.id === "editar" ? "" : "order"}
                                              onClick={(e: any) => {
                                                if (e.target.className.indexOf("delete") > 0 || e.target.className.indexOf("trash") > 0) {
                                                  //

                                                  deleteSorting();
                                                } else {
                                                  if (header.id === "editar") return;

                                                  const sortBy = orderBy === "ASC" ? "DESC" : "ASC"; //
                                                  sortHandler(header.column.columnDef.sortId || header.id, sortBy);
                                                  setOrderByColumn(header.column.columnDef.sortId || header.id); //
                                                  setOrderBy(sortBy);

                                                  setPagination({
                                                    ...pagination,
                                                    ORIENTACION: sortBy,
                                                    ORDENADOPOR: header.column.columnDef.sortId || header.id, //
                                                  });
                                                  callback({
                                                    ...pagination,
                                                    ORIENTACION: sortBy,
                                                    ORDENADOPOR: header.column.columnDef.sortId || header.id, //
                                                  });
                                                }
                                              }}>
                                              {flexRender(header.column.columnDef.header, header.getContext())}
                                              {orderByColumn === header.id || orderByColumn === header.column.columnDef.sortId ? ( //
                                                <span className="ms-1">
                                                  <img height={16} width={16} src={orderBy === "ASC" ? asc : desc} className="bg-transparent" />
                                                  <span className="delete-filter">
                                                    <i className="bi bi-trash text-secondary"></i>
                                                  </span>
                                                </span>
                                              ) : (
                                                ""
                                              )}
                                            </div>
                                          )}
                                        </th>
                                      </React.Fragment>
                                    );
                                  }
                                })}
                              </tr>
                            )
                          )}
                        </thead>
                        {hideFilters || (
                          <tbody>
                            <tr>
                              {table.getHeaderGroups().map(
                                (
                                  headerGroup //
                                ) =>
                                  headerGroup.headers.map((header) => {
                                    if (!(header.column.columnDef as any).hide) {
                                      //
                                      return <td key={header.id}>{RenderOptions(header, filterValue, filterHandler, onChangeFilter, id)}</td>;
                                    }
                                  })
                              )}
                            </tr>
                          </tbody>
                        )}

                        {data.length === 0 ? (
                          <span>No se encontraron registros</span>
                        ) : (
                          <tbody>
                            {table.getRowModel().rows.map((row) => {
                              // NOSONAR "Se aplica en esta linea ya que SONAR nos arroja 50 como valor de complejidad cognitiva. Esta función realiza varias validaciones al ser un componente reutilizable, que se necesita para armar la cabecera de las grillas de los módulos".
                              let r = row.original.TIPO_PROCESO;
                              if (contador === 0) {
                                valor = r;
                                contador++;
                              } else {
                                if (valor !== r) {
                                  valor = r;
                                  contador = 1;
                                } else {
                                  contador++;
                                }
                              }
                              return (
                                <React.Fragment key={row.id}>
                                  {contador === 1 ? (
                                    <>
                                      {" "}
                                      <tr className="trNivel1">
                                        <th colSpan={12}>
                                          <label className="d-block">Tipo de Proceso</label>
                                          {r}{" "}
                                        </th>
                                        <th>
                                          {" "}
                                          <div>
                                            <i
                                              className="bi bi-search iconSearch"
                                              title="Ver Programa"
                                              onClick={() => {
                                                window.location.href = `/agregarprograma?id=${row.original.ID}`;
                                              }}></i>
                                          </div>
                                        </th>
                                      </tr>{" "}
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                  <tr key={row.id}>
                                    {row.original.ID_PLAN > 0 ? (
                                      row.getVisibleCells().map((cell) => {
                                        if (!(cell.column.columnDef as any).hide) {
                                          return (
                                            <td
                                              key={cell.id}
                                              data-id={cell.column.columnDef.id}
                                              className={(cell.column.columnDef as any).className}
                                              onClick={() => {
                                                if ((cell.column.columnDef as any).onSelectColumn)
                                                  (cell.column.columnDef as any).onSelectColumn(cell);
                                              }}>
                                              {cell.id == `${row.id}_editar` ? (
                                                <a
                                                  className="text-decoration-none"
                                                  data-bs-toggle="offcanvas"
                                                  data-bs-target="#offcanvasRight"
                                                  aria-controls="offcanvasRight">
                                                  <i
                                                    className="bi bi-search"
                                                    onClick={() => {
                                                      setShow(true);
                                                      const nRow = row["original"];
                                                      setSelected(nRow);
                                                      loadFromSelected(nRow);
                                                    }}></i>
                                                </a>
                                              ) : (
                                                flexRender(cell.column.columnDef.cell, cell.getContext())
                                              )}
                                            </td>
                                          );
                                        }
                                      })
                                    ) : (
                                      <></>
                                    )}
                                  </tr>
                                </React.Fragment>
                              );
                            })}
                          </tbody>
                        )}
                      </table>
                    )}
                  </div>
                  {hidePagination || (
                    <div className="row justify-content-between">
                      <div className="col-6 d-flex">
                        <span className="me-2 mt-3">
                          <small>Mostrar Filas: </small>
                        </span>
                        <select
                          onChange={(e: any) => {
                            setSelectedPageSize(parseInt(e.target.value));
                            if (callbackUpdatePageSize) {
                              callbackUpdatePageSize(parseInt(e.target.value), filterValue);
                            }
                            callback({
                              ...pagination,
                              PAGINADO: e.target.value,
                            });
                          }}
                          className="form-select form-select-sm selectPaginacion me-5 mt-3">
                          <option selected={selectedPageSize == 5} value="5">
                            5
                          </option>
                          <option selected={selectedPageSize == 10} value="10">
                            10
                          </option>
                          <option selected={selectedPageSize == 20} value="20">
                            20
                          </option>
                          <option selected={selectedPageSize == 50} value="50">
                            50
                          </option>
                        </select>
                      </div>
                      <div className="col-6 d-flex justify-content-end">
                        <div className="d-flex mt-3 me-4">
                          <span className="me-2">
                            <small>Ir a pág:</small>
                          </span>
                          <span className="me-2">
                            <Form.Control
                              type={"number"}
                              className={"form-control-sm"}
                              onChange={(e) => {
                                pageHandler(parseInt(e.target.value));

                                setPagination({
                                  ...pagination,
                                  PAGINA: parseInt(e.target.value),
                                });
                                callback({
                                  ...pagination,
                                  PAGINA: parseInt(e.target.value),
                                });
                              }}
                              name={id}
                              defaultValue={pagination?.PAGINA}
                              value={pagination?.PAGINA}
                              min={1}
                              max={totalPages.current || 1}
                            />
                          </span>
                          <span>
                            <small>de {totalPages.current}</small>
                          </span>
                        </div>
                        <nav aria-label="Page navigation example " hidden={isLoading}>
                          <ul className="pagination justify-content-end mt-3 pagination-sm">
                            <button
                              data-testid="testpagehandler"
                              className={`page-link page-item ${pagination?.PAGINA === 1 ? "disabled" : ""}`}
                              onClick={() => {
                                setPagination({
                                  ...pagination,
                                  PAGINA: pagination?.PAGINA - 1,
                                });
                                callback({
                                  ...pagination,
                                  PAGINA: pagination?.PAGINA - 1,
                                });

                                return pagination != undefined && pagination?.PAGINA > 1 ? pageHandler(pagination?.PAGINA - 1) : false;
                              }}
                              disabled={totalPages.current === 1}
                              hidden={totalPages.current === 1}>
                              Anterior
                            </button>
                            <button
                              className={`page-link page-item ${pagination?.PAGINA === totalPages.current ? "disabled" : ""}`}
                              onClick={() => {
                                setPagination({
                                  ...pagination,
                                  PAGINA: pagination?.PAGINA + 1,
                                });
                                callback({
                                  ...pagination,
                                  PAGINA: pagination?.PAGINA + 1,
                                });
                                return pagination != undefined && pagination?.PAGINA < (totalPages.current || 0)
                                  ? pageHandler(pagination?.PAGINA + 1)
                                  : false;
                              }}
                              hidden={totalPages.current === 1}
                              disabled={totalPages.current === 1}>
                              Siguiente
                            </button>
                          </ul>
                        </nav>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="row">
                <div className="col-6"></div>
                {
                  //hideAdd ||
                  <div className="col-6 text-end">
                    <button
                      hidden={hideExport}
                      className="btn btn-success btn-sm"
                      onClick={() => {
                        exportar();
                      }}>
                      {" "}
                      <i className="bi bi-file-earmark-excel"></i> Exportar
                    </button>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
